export default function TelegramIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="no-change"
    >
      <path
        d="M12 4C9.87875 4 7.8425 4.84338 6.34375 6.34313C4.84347 7.84348 4.00043 9.87823 4 12C4 14.1209 4.84375 16.1571 6.34375 17.6569C7.8425 19.1566 9.87875 20 12 20C14.1213 20 16.1575 19.1566 17.6562 17.6569C19.1562 16.1571 20 14.1209 20 12C20 9.87913 19.1562 7.84288 17.6562 6.34313C16.1575 4.84338 14.1213 4 12 4Z"
        fill="url(#paint0_linear_6537_15189)"
      />
      <path
        d="M7.62107 11.915C9.95357 10.899 11.5086 10.2292 12.2861 9.90554C14.5086 8.98141 14.9698 8.82091 15.2711 8.81548C15.3373 8.81441 15.4848 8.83079 15.5811 8.9086C15.6611 8.97423 15.6836 9.06298 15.6948 9.12529C15.7048 9.18754 15.7186 9.32941 15.7073 9.44016C15.5873 10.7052 15.0661 13.7749 14.8011 15.1918C14.6898 15.7913 14.4686 15.9923 14.2548 16.0119C13.7898 16.0547 13.4373 15.7049 12.9873 15.41C12.2836 14.9484 11.8861 14.6612 11.2023 14.2108C10.4123 13.6903 10.9248 13.4042 11.3748 12.9367C11.4923 12.8143 13.5398 10.9524 13.5786 10.7835C13.5836 10.7624 13.5886 10.6837 13.5411 10.6422C13.4948 10.6005 13.4261 10.6148 13.3761 10.626C13.3048 10.642 12.1811 11.3855 10.0011 12.8564C9.68232 13.0757 9.39357 13.1825 9.13357 13.1769C8.84857 13.1708 8.29857 13.0154 7.88982 12.8827C7.38982 12.7198 6.99107 12.6337 7.02607 12.357C7.04357 12.213 7.24232 12.0657 7.62107 11.915Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6537_15189"
          x1="804"
          y1="4"
          x2="804"
          y2="1604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset="1" stopColor="#229ED9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
